<form class="edit-form" *ngIf="!isLoading" [formGroup]="editForm" (submit)="onSubmit()">
  <mat-form-field>
    <mat-label>{{ 'billing.holidayGroups.edit.name.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="name">
    <mat-error>{{ 'billing.holidayGroups.edit.name.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm" class="actions"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>

<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>